<template>
    <div class="component-orders-table">
        <div>
            <vs-table
              :data="listOrders"
              noDataText="Sem dados disponíveis"
              id="tableDataOrdersChat"
              search
              style="padding-right: 24px !important;"
              @search="searchFilter"
              @sort="sortFilter"
              :max-items="itemsPerPage"
            >
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <vs-dropdown
                        vs-trigger-click
                        class="cursor-pointer mr-4"
                    >
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">
                                {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                                {{
                                    listOrders.length - currentPage * itemsPerPage > 0
                                        ? currentPage * itemsPerPage
                                        : listOrders.length
                                }} de {{ queriedItems }}
                            </span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="itemsPerPage=4" @touchstart.prevent="itemsPerPage=4">
                                <span>4</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="itemsPerPage=10" @touchstart.prevent="itemsPerPage=10">
                                <span>10</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="itemsPerPage=15" @touchstart.prevent="itemsPerPage=15">
                                <span>15</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="itemsPerPage=20" @touchstart.prevent="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
                
                <template slot="thead">
                    <vs-th class="text-base formatHead" sort-key="orders.turned_order_at">
                        Nº
                    </vs-th>
                    <vs-th class="text-base formatHead" sort-key="orders.ids">
                        Data Criação
                    </vs-th>
                    <vs-th class="text-base formatHead" sort-key="chat_tickets.customers.name">
                        Nome
                    </vs-th>
                    <vs-th class="text-base formatHead" sort-key="chat_tickets.customers.document_register">
                        Documento
                    </vs-th>
                    <vs-th class="text-base formatHead" sort-key="chat_tickets.customers.phone_number">
                        Telefone
                    </vs-th>
                    <vs-th class="text-base formatHead" sort-key="users.name">
                        Usuário
                    </vs-th>
                    <vs-th class="text-base text-center flex justify-center" sort-key="orders.is_finished_at">
                        Finalizado
                    </vs-th>
                    <vs-th class="text-base text-center">
                        Status do Pedido
                    </vs-th>
                </template>
      
                <template slot-scope="{data}">
                    <tbody  @click="alterCollspan()" style="width: 10em;">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                            
                            <vs-td :data="tr.id">
                                <p class="text-left formatHeadName">
                                    {{ tr.id }}
                                </p>
                            </vs-td>

                            <vs-td :data="tr.turned_order_at">
                                <p class="text-left formatHeadName">
                                    {{ tr.turned_order_at }}
                                </p>
                            </vs-td>

                            <vs-td :data="tr.chatTicket.customer.name">
                                <p class="text-left formatHeadName">
                                    {{ tr.chatTicket.customer.name }}
                                </p>
                            </vs-td>

                            <vs-td :data="tr.chatTicket.customer.document_register">
                                <p class="text-left formatHeadName">
                                    {{ 
                                        tr.chatTicket.customer.document_register 
                                        ? formatDocument(tr.chatTicket.customer.document_register) 
                                        : '-' 
                                    }}
                                    
                                </p>
                            </vs-td>

                            <vs-td :data="tr.chatTicket.customer.phone_number">
                                <p class="text-left formatHead">
                                    {{ parsePhoneNumber(tr.chatTicket.customer.phone_number) }}
                                </p>
                            </vs-td>

                            <vs-td :data="tr.chatTicket.customer.phone_number">
                                <p class="text-left formatHead">
                                    {{ tr.user ? tr.user.name : 'Não informado' }}
                                </p>
                            </vs-td>

                            <vs-td :data="tr.is_finished_at" style="border-top:1px solid #b6bebd6e; border-bottom:1px solid #b6bebd6e;">
                                <span id="alignVsChip" >
                                    <vs-chip
                                    v-if="tr.is_finished_at === null"
                                    color="danger"
                                    class="text-center formatHeadName"
                                    >
                                        <p class="text-center"> Não </p>
                                    </vs-chip>

                                    <vs-chip
                                        v-else
                                        color="success"
                                        class="text-center formatHeadName"
                                    >
                                        <p class="text-center"> Sim </p>
                                    </vs-chip>
                                </span>
                            </vs-td>
                           
                            <vs-td class="align-button-flex" v-if="tr.status">
                                <div class="dropdown-tooltip-container">
                                <span @mouseover="toggleExpansive" @mouseleave="unToggleExpansive">
                               
                                    <vs-dropdown vs-custom-content vs-trigger-click  style="width: 70%;" class="formatHeadStatus">
                                        <vs-button
                                            class="btn-drop px-3 attendance-span"
                                            type="filled"
                                            icon="expand_more"
                                            :color="tr.status.color"
                                            size="small"
                                            style="font-size: 1rem !important; width: 100%"
                                            icon-after
                                            
                                        >
                                            <span>
                                                {{ truncateText(tr.status.name, 25) }}
                                            </span>
                                        </vs-button>

                                        <vs-dropdown-menu>
                                            <div class="scrollable-dropdown-content">
                                                <div v-for="(item, index) in statuses" :key="index">
                                                    <vs-dropdown-item
                                                        v-if="item.id !== tr.status_id"
                                                        :style="colorOfOption(item.color)"
                                                        style="color: #fff; width: 100%;"
                                                        class="m-0"
                                                        @click.prevent="statusAdvice(item, tr)"
                                                        @touchstart.prevent="statusAdvice(item, tr)"
                                                    >
                                                        <span style="word-break: break-all;">{{ item.name }}</span>
                                                    </vs-dropdown-item>
                                                </div>
                                            </div>
                                        </vs-dropdown-menu>
                                    </vs-dropdown>
                                </span>
                                
                                <vx-tooltip  
                                    position="left" 
                                    v-if="hasErpFeature && tr.erp_id"
                                    :text="getErpText(tr.erp.erp_id)"
                                >
                                    <feather-icon icon="HelpCircleIcon" class="mr-4 mt-2"/>
                                </vx-tooltip>

                                </div>
                            </vs-td>

                            <vs-td class="align-button-flex" v-else>
                                <vs-dropdown vs-custom-content vs-trigger-click style="width: 70%;" class="formatHeadStatus">
                                    <vs-button
                                        class="btn-drop pt-3 pb-3 attendance-span"
                                        type="filled"
                                        size="small"
                                        style="font-size: 1rem !important; width: 100%;s"
                                        icon-after
                                    >
                                        <span>
                                        Serviço
                                        </span>
                                    </vs-button>
                                </vs-dropdown>
                            </vs-td>

                            <template slot="expand">
                                <vs-row style="min-height: 13rem; width:90%;" v-if="!statusDropDown">
                                    <vs-tabs>
                                        <vs-tab :disabled="tr.orderProducts[0] ? false : true" label="Produtos" icon="shopping_basket" size="small">
                                            <vs-col vs-lg="9" vs-sm="6" vs-xs="12">
                                                <ProductOrdersChildrensVue
                                                    :idOrder="tr.id"
                                                    :isService="false"
                                                    :services="null"
                                                />
                                            </vs-col>
                                        </vs-tab>
                                        <vs-tab :disabled="tr.services[0] ? false : true" label="Serviços" icon="build" size="small">
                                            <vs-col vs-lg="9" vs-sm="6" vs-xs="12">
                                                <ProductOrdersChildrensVue
                                                    :idOrder="tr.id"
                                                    :isService="true"
                                                    :services="tr.services"
                                                />
                                            </vs-col>
                                        </vs-tab>

                                        
                                        <vs-tab 
                                        :disabled="files(tr.files).length === 0 && !tr.note" 
                                        icon="description" 
                                        size="small"
                                        label="Arquivos e Observação"
                                        >
                                            <vs-table
                                            ref="table" 
                                            :data="files(tr.files)"
                                            noDataText="Sem dados disponíveis"
                                            id="tableServicePreOrdersSummaryChat"
                                            style="padding: 0 !important;"
                                            v-if="files(tr.files).length > 0"
                                            :pagination="files(tr.files).length > 5"
                                            >
                                                <template slot="thead">
                                                    <vs-th class="text-base">
                                                        Nome
                                                    </vs-th>
                                                    <vs-th class="text-base">
                                                        Download
                                                    </vs-th>
                                                </template>

                                                <template slot-scope="{data}">
                                                    <tbody>
                                                        <vs-tr 
                                                            :data="tr" 
                                                            :key="tr.id"
                                                            :id="tr.id"
                                                            v-for="(tr, index) in data"
                                                        >
                                                            <vs-td :data="tr.name">
                                                                <p class="ml-4">
                                                                    {{ tr.name }}
                                                                </p>
                                                            </vs-td>

                                                            <vs-td style="display: flex; justify-content: center; align-items: center;">
                                                                <feather-icon 
                                                                icon="DownloadIcon" 
                                                                svgClasses="h-5 w-5"
                                                                @click="downloadFile(tr.name, tr.url, tr.documentMimetype)"
                                                                />
                                                            </vs-td>
                                                            
                                                        </vs-tr>
                                                    </tbody>
                                                </template>
                                            </vs-table>

                                            <div v-if="tr.note" class="pl-3 mt-3 mb-2">
                                                <strong>Observação:</strong> {{ tr.note }}
                                            </div>
                                        </vs-tab>

                                        <vs-tab
                                        icon="import_contacts"
                                        size="small"
                                        label="Modelo de Dados ..."
                                        title="Modelo de Dados do Clientes"
                                        :disabled="!tr.reason"
                                        >
                                            <OrderCustomerKnowInfos
                                                :customerKnow="parseCustomerKnow(tr.customer_knowledge_content)"
                                            />
                                        </vs-tab>

                                    </vs-tabs>
                                </vs-row>
                                <vs-row v-if="!statusDropDown">
                                    <div class="order-infos-div fixed-div-bottom" v-bind:style="bindStyle()"> 
                                    <div v-if="tr.is_delivery">
                                        
                                        <img :src="orderDelivery" alt="Foto do Entregador">
                                        <span> Entregador </span>
                                    </div>
                                    <div v-else-if="showWithdrawal(tr.address)">
                                        
                                        <vs-icon icon="store" size="40px"/>
                                        <span> Retirada </span>
                                    </div>
                                    <div v-if="getType(tr.payment_data) !== 'none'">
                                        <img
                                        v-if="getType(tr.payment_data) === 'card'"
                                        src="@/assets/images/payment/card.png"
                                        alt="Imagem Cartão"
                                        class="card-resize"
                                        />
                                        <img
                                        v-else-if="getType(tr.payment_data) === 'pix'"
                                        src="@/assets/images/payment/pix.png"
                                        alt="Imagem Pix"
                                        class="pix-resize"
                                        />
                                        <img
                                        v-else-if="getType(tr.payment_data) === 'cash'"
                                        src="@/assets/images/payment/cash.png"
                                        alt="Imagem Dinheiro"
                                        class="cash-resize"
                                        />
                                        <span v-if="getType(tr.payment_data) === 'card'" style="border-radius: 0 !important;"> Cartão </span>
                                        <span class="mt-2" v-else-if="getType(tr.payment_data) === 'pix'"> Pix </span>
                                        <span class="mt-2" v-else-if="getType(tr.payment_data) === 'cash'"> Dinheiro </span>
                                    </div>
                                    <div v-if="tr.is_delivery">
                                        <vs-icon icon="motorcycle" size="medium"/>
                                        <span> Entrega </span>
                                    </div>
                                    </div>
                                </vs-row>
                                <span v-if="statusDropDown"></span>
                            </template>
                        </vs-tr>
                    </tbody>
                </template>
            </vs-table>

            <div class="mt-3 mr-4">
                <vs-pagination
                    :total="totalPages"
                    v-model="page"
                    @change="closeExpand"
                    max="7"
                />
            </div>
        </div>

        <vs-popup title="Finalizar Pedido:"
            :active.sync="modalToFinishOrder"
        >
            <p> Clique em confirmar para finalizar o Pedido!
            </p> <br>
            <div class="w-full d-flex justify-content-flex-end">
            <vs-button color="success" @click.stop="finishOrder(targetToFinish)">Confirmar</vs-button>
            </div>
        </vs-popup>

    </div>
</template>

<script>
    import moduleOrder from "@/store/order/moduleOrder";
    import ProductOrdersChildrensVue from "@/views/orders/product-orders/ProductOrdersChildrens.vue";
    import orderHttp from "@/http/requests/orders";
    import moduleStatus from '@/http/requests/status';
    import { hasFeature } from "@/utils";
    import VsDropdown from "@/components/vs-dropdown/dropdown.vue";
    import VsDropdownMenu from "@/components/vs-dropdown/dropdown-menu.vue";
    import VsDropdownItem from "@/components/vs-dropdown/dropdown-item.vue";
    import axios from 'axios'
    import OrderCustomerKnowInfos from "./OrderCustomerKnowInfos.vue";
    import { maskPhoneNumber } from "@/utils";

    export default {
        name: 'OrdersPopUp',
        components: {
            VsDropdown,
            VsDropdownMenu,
            VsDropdownItem,
            ProductOrdersChildrensVue,
            OrderCustomerKnowInfos
        },
        data() {
            return {
                statuses: [],
                search: '',
                orderBy: {
                    name: 'orders.turned_order_at',
                    type: 'DESC',
                    lastDesc: true
                },
                modalToFinishOrder: false,
                targetToFinish: 0,
                page: 1,
                currentPage: 1,
                itemsPerPage: 4,
                isMounted: false,
                hasErpFeature: false,
                statusDropDown: false,
                selected: 1,
                maxLength: 30,
                statusDropDown: false,
                selected: 1,
                maxLength: 30,
                customerKnow: {}
            }
        },
        emits: [
            'isActiveFalse'
        ],
        methods: {
            truncateText(text, maxLength) {
                if (text.length > maxLength) {
                    return text.substring(0, maxLength) + '...';
                }
                return text;
            },
            closeExpand () {
                let $target = [];
                this.$refs.vsTrElement.forEach((element) => {
                    if (element.expanded === true) { 
                        $target.push(element)
                    }
                })
                $target.forEach(element => element.$el.click())
            },
            async fetchStatus() {
                await moduleStatus.fetch()
                .then((response) => {
                    return this.statuses = response.data.data.getStatus;
                })
                .catch((exception) => {
                    console.log(exception);
                    return this.$vs.notify({
                        color: 'danger',
                        title: 'Erro',
                        text: 'Houve algum erro ao carregar os dados!'
                    });
                });
            },
            colorOfOption(color) {
              return {
                backgroundColor: color
              }
            },
            changeOrderStatus(newStatus, order) {
                const maxStatusLength = 20;
                
                const shortenedCurrentStatus = order.status.name.length > maxStatusLength
                    ? order.status.name.substring(0, maxStatusLength) + "..." 
                    : order.status.name;
                
                const shortenedNewStatus = newStatus.name.length > maxStatusLength
                    ? newStatus.name.substring(0, maxStatusLength) + "..." 
                    : newStatus.name;
                
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'warning',
                    title: `Deseja atualizar o status do pedido?`,
                    text: `O pedido irá passar do status "${shortenedCurrentStatus}", para o status "${shortenedNewStatus}".`,
                    accept: () => this.confirmChangeOrderStatus(newStatus, order),
                    acceptText: 'Alterar',
                    cancelText: 'Voltar'
                });
            },

            statusAdvice(newStatus, order) {
                this.$vs.dialog({
                    type: 'alert',
                    color: 'primary',
                    title: `Atenção!`,
                    text: 'O status será atualizado no Pedbot mas não no Sistema ERP, você precisará atualizar o status por meio da aplicação do ERP. Entre em contato com o Sistema ERP e solicite a liberação dessa funcionalidade.' ,
                    accept: () => this.changeOrderStatus(newStatus, order),
                    acceptText: 'Ok',
                })
            },
            async confirmChangeOrderStatus(newStatus, order) {
              await this.$store.dispatch("order/update", {
                id: order.id,
                status_id: newStatus.id
              }).then(() => {
                this.$vs.notify({
                  color: 'success',
                  title: 'Sucesso!',
                  text: 'Atualização feita com sucesso!'
                })
              }).catch((exception) => {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Erro!',
                  text: 'Erro ao atualizar os dados, por favor nos contate para corrigir-mos!'
                });
              });
              if (newStatus.step === 'Pedido Finalizado' && order.is_finished_at === null) {
                this.prepareToFinish(order.id)
              }
            },
            async dataLoad() {
                if (!moduleOrder.isRegistered) {
                    this.$store.registerModule('order', moduleOrder)
                    moduleOrder.isRegistered = true
                }
                await this.$store.dispatch("order/fetchAll", {
                    sortName: this.orderBy.name,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage,
                    type: this.orderBy.type,
                    word: this.search
                });

                this.fetchStatus();
            },
            closePopUp() {
                this.$emit('closePopup');
            },
            alterCollspan() {
                const tr = document.querySelectorAll('.tr-expand > td');
                tr.forEach((item) => {
                    item.colSpan = 7;
                })
            },
            async searchFilter(searchQuery) {
                this.closeExpand();
                this.search = searchQuery;
                this.dataLoad();
            },
            async sortFilter(sortName) {
                this.closeExpand();
                if (sortName !== null) {
                    if (sortName !== this.orderBy.name) {
                        this.orderBy.name = sortName;
                        this.orderBy.type = 'ASC';
                    } else if (this.orderBy.type !== "" && this.orderBy.type === "ASC") {
                        this.orderBy.type = 'DESC';
                    } else if (this.orderBy.lastDesc && this.orderBy.name === 'orders.turned_order_at') {
                        this.orderBy.type = 'ASC';
                        this.orderBy.lastDesc = false;
                    } else if (this.orderBy.name === sortName && this.orderBy.type === "DESC") {
                        this.orderBy.name = 'orders.turned_order_at';
                        this.orderBy.type = 'DESC';
                        if (this.orderBy.name === 'orders.turned_order_at') {
                            this.orderBy.lastDesc = true;
                        }
                    }
                    await this.dataLoad();
                }
            },
            prepareToFinish(id) {
                this.modalToFinishOrder = true;
                this.targetToFinish = id;
            },
            finishOrder(id) {
                this.modalToFinishOrder = false;
                orderHttp.finishOrder(id)
                .then((response) => {
                    const orderIndex = this.listOrders.findIndex((order) => order.id === id);
                    this.listOrders[orderIndex].is_finished_at = new Date();
                    this.$vs.notify({
                        color: 'success',
                        title: 'Pedido finalizado!',
                        text: 'O pedido foi finalizado com sucesso!'
                    });
                })
                .catch((exception) => {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Ocorreu um erro ao finalizar o pedido!',
                        text: 'Erro ao finalizar o pedido, por favor nos contate para corrigir-mos!'
                    });
                    console.log(exception)
                });
            },
            getType(data) {
                return (JSON.parse(data)).type;
            },
            bindStyle() {
                if (this.$route.name === 'chat-attendance') {
                    return {
                        marginBottom: '8px'
                    }
                }
                return {
                    marginBottom: '16px'
                }
            },
            toggleExpansive() {
                this.statusDropDown = true;
            },
            unToggleExpansive() {
                this.statusDropDown = false;
            },
            files(value) {
                if (value) {
                    return JSON.parse(value);
                } else {
                    return [];
                }
            },
            downloadFile(documentName, url, documentMimetype) {
                axios.get(url, {
                    responseType: 'blob'
                }).then(res => {
                    var blob = new Blob(
                    [res.data],
                    { type: `${documentMimetype};charset=utf-8;` }
                    )

                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = documentName
                    link.click()
                    window.URL.revokeObjectURL(link.href)
                });
            },
            parseCustomerKnow(customerKnow) {
                return JSON.parse(customerKnow);
            },
            closePopUp() {
                this.modalToFinishOrder = false;
            },
            showWithdrawal(address) {
                if (address) {
                    const formatedAddress = JSON.parse(address);
                    if (formatedAddress.address === 'none') {
                        return false;
                    }
                }
                return true;
            },
            parsePhoneNumber(number) {
                return maskPhoneNumber(number);
            },
            formatDocument(doc) {
                doc = doc.replace(/\D/g, '');

                if (doc.length === 11) {
                    return doc.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
                } else if (doc.length === 14) {
                    return doc.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
                } else {
                    return 'Documento inválido';
                }
            },
            getErpText(id) {
                // o numero 1 é o id da trier
                // o numero 2 é o id da alpha7
                if (id === 1) {
                    return 'Não é possível atualizar o status com o Sistema ERP automaticamente. \
                    Você precisará atualizar o status por meio da aplicação do ERP. \
                    Por favor, entre em contato com o Sistema ERP e solicite a liberação dessa funcionalidade.'
                }
                else if (id === 2) {
                    return 'Ao definir esse status como "Cancelado" ou "Entregue / Finalizado", será automaticamente atualizado no sistema ERP.';
                }
            }
        },
        watch: {
            'page'() {
                this.dataLoad()
            },
            'itemsPerPage'() {
                this.page = 1
                this.dataLoad()
            }
        },
        computed: {
            totalPages() {
                return this.$store.state.order && this.$store.state.order.orders.total_pages
                    ? this.$store.state.order.orders.total_pages
                    : 0
            },
            queriedItems() {
                return this.$store.state.order && this.$store.state.order.orders.total_items
                    ? this.$store.state.order.orders.total_items
                    : 0
            },
            listOrders() {
               return this.$store.state.order ? this.$store.state.order.orders.items : [];
            },
            orderDelivery() {
                return this.$store.state.AppActiveUser.image;
            }
        },
        async mounted() {
            this.$store.dispatch('setShowLoadingOverlay', false)

            await this.dataLoad();
            this.hasErpFeature = await hasFeature('erps')
            this.isMounted = true;
        },
        created() {
            this.$events.on('closeAllPopUps', this.closePopUp);
        },
        beforeDestroy() {
            this.$events.off('closeAllPopUps', this.closePopUp);
        }
    }
</script>


<style lang="scss" scoped>
    .tooltip-erp-msg {
        position: absolute;
        top: 50%;
        left: 80%;
        transform: translate(0, -50%);
    }
    .dropdown-tooltip-container {
        display: flex;
        align-items: center;
        position: relative;
    }
    #tableDataOrdersChat {
        .vs-con-tbody.vs-table--tbody {
            background-color: transparent !important;
            border: 0 !important; 
        }
        table.vs-table.vs-table--tbody-table {
            border-collapse: separate;
            border-spacing: 0 0.5rem;
            padding: 0 1rem;
        }
        header {
            margin-left: 16px;
            margin-right: 16px;
            div > input {
                border: solid 0.1px !important;
                color: #726f6fb4;
            }
        }
        tbody {  
            tr {
                td {
                    padding: 0px;
                    border-style: solid; 
                    border-color: #b6bebd6e;
                    padding-right: 6px;
                    height: 4em;
                }
                td.td-check {
                    display: flex;
                }
                td.td-check.active-expanded {
                    display: flex;
                    flex-direction: row;
                    align-content: center;
                    flex-wrap: wrap;
                }
                td:first-of-type {
                    border-top-left-radius: 14px; 
                    border-bottom-left-radius: 14px; 
                    border-width: 1px 0px 1px 1px;
                }
                td:nth-of-type(2), td:nth-of-type(3), td:nth-of-type(4), td:nth-of-type(5) {
                    border-width: 1px 0px 1px 0px; 
                }
                td:last-of-type {
                    border-width: 1px 1px 1px 0px;
                    border-top-right-radius: 14px;
                    border-bottom-right-radius: 14px;
                    padding-right: 10px;
                }
                td.ajuste-tamanho-vstd-preorders {
                    padding-right: 10px;
                    width: 160px;
                    border-width: 1px 0px 1px 0px; 
                    div {
                        float: right;
                        button {
                            display: flex;
                            border-radius: 15px;
                            height: 35px;
                            padding: 0px 16px 0px 25px;
                            justify-content: center;
                        }
                        span.vs-button-text.vs-button--text {
                            display: flex;
                            flex-direction: row;
                            justify-content: center;
                            align-items: center;
                        }
                    }
                }
            }
        }
        .pix-resize {
            width: 60px !important;
            height: 23px !important;
        }
        .card-resize {
            border-radius: 0 !important;
            height: 35px !important;
            width: 50px !important;
        }
        .cash-resize {
            width: 40px !important;
            height: 30px !important;
        }
    }
    span#alignVsChip {
        display: flex;
        justify-content: center;
    }
    .scrollable-dropdown-content {
        max-height: 250px; 
        overflow-y: auto;
    }
</style>
